export default "__VITE_ASSET__CG_fWa$k__"